import {
  RuleField,
  RuleOperator,
  ConditionJoin,
  FIELD_LABELS,
  OPERATOR_LABELS,
  CONDITION_JOIN_LABELS,
  formatRuleConditions,
  type RuleConditionValue,
} from 'features/RuleBuilder'

export type { RuleConditionValue }

export type AutoEnrollField = RuleField
export type AutoEnrollOperator = RuleOperator

export type { ConditionJoin }

/**
 * A single auto-enroll rule. Matches backend AutoEnrollmentRule model.
 * When an employee matches the condition(s), they are added to the listed groups and tags after sync.
 */
export interface AutoEnrollRule {
  id: string
  field: AutoEnrollField
  operator: AutoEnrollOperator
  value: RuleConditionValue
  /** Optional second condition; omit or null all secondary fields for a single-condition rule. */
  secondaryField?: AutoEnrollField | null
  secondaryOperator?: AutoEnrollOperator | null
  secondaryValue?: RuleConditionValue | null
  conditionJoin?: ConditionJoin | null
  /** Optional third condition; requires secondary. Chained left-to-right. */
  tertiaryField?: AutoEnrollField | null
  tertiaryOperator?: AutoEnrollOperator | null
  tertiaryValue?: RuleConditionValue | null
  tertiaryConditionJoin?: ConditionJoin | null
  /** Target custom group (segment) ids; API field `segments`. */
  segments: string[]
  /** Target tag ids; API field `tags`. */
  tags?: string[]
  isActive?: boolean
  /** When true, members in the group who no longer match this rule are removed. */
  removeNonMatchingMembers?: boolean
}

export const AUTO_ENROLL_FIELD_LABELS = FIELD_LABELS
export const AUTO_ENROLL_OPERATOR_LABELS = OPERATOR_LABELS
export { CONDITION_JOIN_LABELS }

/** Human-readable summary for table display. */
export function formatAutoEnrollRuleConditions(rule: AutoEnrollRule): string {
  return formatRuleConditions(rule)
}
